/**
 * Marketplace condition formatting utility
 * Maps condition values to display labels
 */

const CONDITION_LABELS = {
  'new': 'New',
  'like_new': 'Used - Like New',
  'good': 'Used - Good',
  'fair': 'Used - Fair',
  'refurbished': 'Refurbished',
  // Legacy values
  'excellent': 'Used - Like New',
  'poor': 'Used - Fair',
};

export const formatCondition = (condition) => {
  if (!condition) return '';
  return CONDITION_LABELS[condition] || condition.replace(/_/g, ' ');
};

export default formatCondition;
